import { RapidStorInsurance } from "../../../services/rapidstor";

export default interface Insurance {
  hidden: boolean;
  deleted: boolean;
  maxArea: number;
  // helpfulText: string;
  _id: string;
  insuranceCoverageId: number;
  locationCode: string;
  siteId: number;
  changeToken: string;
  changedAt: string;
  coverage: number;
  premium: number;
  weeklyPremium: number;
  coverageDescription: string;
  providor: string;
}

export interface InsuranceList {
  insuranceTypes: Insurance[];
}

export const insuranceTransformer = (insurance: RapidStorInsurance): Insurance => {
  return {
    deleted: insurance.deleted,
    maxArea: insurance.maxArea,
    hidden: insurance.hidden,
    // helpfulText: insurance.helpfulText,
    _id: insurance._id,
    insuranceCoverageId: insurance.InsurCoverageID,
    locationCode: insurance.sLocationCode,
    siteId: insurance.SiteID,
    changeToken: insurance.changeToken,
    changedAt: insurance.changedAt,
    coverage: insurance.dcCoverage,
    premium: insurance.dcPremium,
    weeklyPremium: insurance.dcPremium / 4,
    coverageDescription: insurance.dcCoverageDesc,
    providor: insurance.sProvidor,
  };
};
